module.exports = __webpack_public_path__ + "img/zuqius.1812f33f.png";